import { BCMSRecord, BCMSStateManagerCRUD, useGlobalController } from "@bcm-dev/bcms-vite";
import DepositACheckConfirmationPage, { getDefaultPageData } from "components/pages/DepositACheckConfirmationPage";
import Classes, { Account } from "model";

export default function CaptureMabiDepositsDepositComplete(props) {
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const account = Account.getDefaultBrandedAccountByType("checking");
    
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update(["deposit", "amount"], 20)
        .update(["deposit", "account"], Account.initByID(account.id))
        .submit();


    return <DepositACheckConfirmationPage data={data} />
}

